export const tvStatuses = ['Development', 'Pilot', 'Series'];
